import { render, staticRenderFns } from "./CookieAccept.vue?vue&type=template&id=0ae852c7&"
import script from "./CookieAccept.vue?vue&type=script&lang=js&"
export * from "./CookieAccept.vue?vue&type=script&lang=js&"
import style0 from "./CookieAccept.vue?vue&type=style&index=0&id=0ae852c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports